// Background song playback.
import * as audioContext from "./audio-context.ts";

let loaded:boolean = false;
let isPaused: boolean = false;

let audioSound: AudioBufferSourceNode | null;
let buffer: AudioBuffer | null;
let gain: GainNode | null;

const clampVolume = (value: number): number => {
    if (Number.isNaN(value)) return 0;
    return Math.min(1, Math.max(0, value));
};

export async function init(url: string, volume: number): Promise<void>
{
    if (!audioContext.context)
        return;

    if (audioSound) {
        audioSound.stop();
        audioSound = null;
    }

    if (gain) {
        gain.disconnect();
        gain = null;
    }

    isPaused = false;
    loaded = false;

    const res = await fetch(url, { cache: "force-cache" });
    if (!res.ok) throw new Error(`Failed to fetch audio (${res.status})`);

    const arrayBuffer = await res.arrayBuffer();
    buffer = await audioContext.context.decodeAudioData(arrayBuffer);

    audioSound = audioContext.context.createBufferSource();
    audioSound.loop = true;
    audioSound.buffer = buffer;

    gain = audioContext.context.createGain();
    gain.gain.value = clampVolume(volume);

    audioSound.connect(gain);
    gain.connect(audioContext.context.destination);

    // start(when, offset, duration)
    audioSound.start();

    loaded = true;
}

export function pause() {
    // prevent double call
    if (isPaused)
        return;

    // state
    isPaused = true;

    if (!audioContext.context)
        return;

    if (!loaded)
        return;

    if (!audioSound)
        return;

    audioSound.stop();
    //pausedAt += audioContext.context.currentTime;
    audioSound = null;
}

export function unPause() {
    // prevent double call
    if (!isPaused)
        return;

    // state
    isPaused = false;

    if (!audioContext.context)
        return;

    if (!loaded)
        return;

    if (!buffer)
        return;

    if (audioSound) {
        audioSound.stop();
        audioSound = null;
    }

    // restart playback
    audioSound = audioContext.context.createBufferSource();
    audioSound.loop = true;
    audioSound.buffer = buffer;
    if (gain)
        audioSound.connect(gain);

    audioSound.start();
}

export function setVolume(volume: number): void {
    if (!gain) return;
    gain.gain.value = clampVolume(volume);
}

export function getVolume(): number | null {
    return gain ? gain.gain.value : null;
}

export function hasAudio(): boolean {
    return loaded;
}

export function isPlaying(): boolean {
    return loaded && !isPaused;
}
